import { SkeletonDots } from '@yes.technology/react-toolkit'
import React from 'react'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import { SafeHtmlContent } from 'site/shared/components/SafeHtmlContent'
import { useSiteState } from 'siteState/shared'
import {
  StyledSkeletonDots,
  StyledText,
  StyledToolkitText
} from './TextExpressionContainer.style'
import { TextExpressionContainerProps } from './TextExpressionContainer.types'

const TextExpressionContainer = ({ props }: TextExpressionContainerProps) => {
  const { des, variant, alignment = 'center', styleMap } = props
  const styleProps = useStyleMaps(styleMap)

  const [allResultsFetched] = useSiteState('allResultsFetched')
  const isLoading = !allResultsFetched
  const textProps = [variant, alignment].filter(Boolean)

  const TextComponent: React.ComponentType<
    React.ComponentProps<typeof StyledToolkitText>
  > = Object.keys(textProps).length > 0 ? StyledToolkitText : StyledText

  return (
    <div style={styleProps}>
      {isLoading ? (
        <StyledSkeletonDots>
          <SkeletonDots />
        </StyledSkeletonDots>
      ) : (
        <TextComponent variant={variant} alignment={alignment}>
          <SafeHtmlContent html={des} />
        </TextComponent>
      )}
    </div>
  )
}

export default TextExpressionContainer
